import React from 'react';
import { Box, Typography, Grid, Divider } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useToast } from "@chakra-ui/core";
import Input from '../../../../components/Input';
import Button from 'src/components/Button';
import { AiOutlineClose } from 'react-icons/ai';
import api from 'src/service/api';

import useStyles from './styles';

interface IModalProps {
  open: boolean;
  handleClose: () => void;
  handlecancel: () => void;
  handleBack: () => void;
}

type CollaboratorProps = {
  gpId: string,
  level: string,
  fullName: string,
  email: string,
  hiringDate: string,
}

const FormCollaborators = (props: IModalProps) => {
  const classes = useStyles();
  const { register, handleSubmit, errors } = useForm();
  const toast = useToast();
  

  const handleSubmitForm: SubmitHandler<CollaboratorProps> = async (values) => {
    const [firstName, ...secondName] = values.fullName.split(' ');

    const formatValues = {
      ...values,
      firstName,
      lastName: secondName.join(' '),
    }

    Reflect.deleteProperty(formatValues, 'fullName')

    try {
      await api.post('/user', formatValues)
      props.handlecancel()
      toast({
        position: "top-right",
        title: "Cadatro realizado.",
        description: "Você cadastrou um novo colaborador",
        status: "success",
        duration: 4000,
        isClosable: true,
      });
    } catch (error) {
      props.handlecancel();
      toast({
        position: "top-right",
        title: "Algo deu errado.",
        description: "Você já se cadastrou esse colaborador",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby=""
        classes={{ paper: classes.dialogPaper }}
      >
        <Box component="header" className={classes.header}>
          <Typography className={classes.title}>
            Cadastrar um novo Colaborador
          </Typography>
          <button type="button" onClick={props.handlecancel}>
            <AiOutlineClose size={16} />
          </button>
        </Box>
         <form onSubmit={handleSubmit(handleSubmitForm)} style={{ marginTop: '16px'}}>
            <Grid container spacing={1}>
              <Grid item xs={8}>
                <Input 
                  isFullWidth
                  id='gpId'
                  name='gpId'
                  label='Gpid'
                  ref={register({ required: 'Gpid é obrigatório'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={4}>
                <Input 
                  isFullWidth
                  id='level'
                  name='level'
                  label='Nível'
                  ref={register({ required: 'level é obrigatório'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={12}>
                <Input 
                  id='fullName'
                  name='fullName'
                  label='Nome completo'
                  ref={register({ required: 'Nome é obrigatório'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={12}>
                <Input 
                  id='email'
                  name='email'
                  label='E-mail'
                  type='email'
                  ref={register({ required: 'E-mail é obrigatório'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={12}>
                <Input 
                  name='hiringDate'
                  label='Data de adimissão'
                  type='date'
                  ref={register({ required: 'A data de adimissão é obrigatória'})}
                  error={errors}
                />
              </Grid>
            </Grid>       
            <Divider style={{ width: '100%'}}/>
          <Box className={classes.wrapperButtons}>
            <Button
              fill={false}
              onClick={props.handlecancel}
            >
              Cancelar
            </Button>
            <Button type="submit" className={classes.button}>
              Adicionar Colaborador
            </Button>
          </Box>
        </form>
      </Dialog>
    </>
  );
};
export default FormCollaborators;